import styles from "./UnsavedChangesModal.module.css";
import warningIcon from "../../../../assets/warning-icon.svg";
import BaseModal from "../../../common/modals/BaseModal/BaseModal";
import ModalCloseButton from "../../../common/modals/ModalCloseButton/ModalCloseButton";
import StyledButton from "../../buttons/StyledButton";

const strings = {
  leaveWithoutSaving: "Leave Without Saving?",
  messageLine1: "You have unsaved changes.",
  messageLine2: "Are you sure you want to cancel and lose all progress?",
  keepEditing: "Keep Editing",
  cancelChanges: "Cancel Changes",
};

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  onConfirm: () => void;
};

export default function UnsavedChangesModal({
  isOpen,
  onRequestClose,
  onConfirm,
}: Props) {
  return (
    <BaseModal
      className={styles.modal}
      label={strings.leaveWithoutSaving}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <ModalCloseButton onClick={onRequestClose} />

      <div className={styles.modalContent}>
        <img src={warningIcon} alt="" />

        <div>{strings.messageLine1}</div>
        <div>{strings.messageLine2}</div>

        <StyledButton
          className={styles.stayOnPageButton}
          onClick={onRequestClose}
        >
          {strings.keepEditing}
        </StyledButton>
        <StyledButton
          className={styles.cancelChangesButton}
          variant="danger"
          onClick={onConfirm}
        >
          {strings.cancelChanges}
        </StyledButton>
      </div>
    </BaseModal>
  );
}
